import type { ImagineUIDataParts } from "@imagine/ai-service/shared-types";
import { Suggestion } from "../ai-elements/suggestion";
import { motion, AnimatePresence } from "motion/react";
import { useSendMessage } from "@/hooks/use-send-message";
import { imagineStore } from "@/stores/imagine.store";

export function SuggestionList({
  part,
}: {
  part: ImagineUIDataParts["suggestions"];
}) {
  const projectId = imagineStore.use.projectId();
  const sendMessage = useSendMessage();
  const handleSuggestionClick = (suggestion: string) => {
    sendMessage({ projectId: projectId!, text: suggestion });
  };

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key="suggestion-list"
        className="space-y-3"
        initial={{ y: 100 }}
        animate={{ y: 0 }}
        exit={{ opacity: 0 }}
        transition={{
          y: { duration: 0.4, ease: "easeOut" },
          opacity: { duration: 0.4 },
        }}
      >
        <div className="text-xs text-muted-foreground mt-4">Suggestions:</div>
        <div className="flex flex-wrap gap-2">
          {part.suggestions.map((suggestion, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                delay: 0.7 + index * 0.25,
                duration: 0.3,
                ease: "easeOut",
              }}
            >
              <Suggestion
                suggestion={suggestion}
                onClick={handleSuggestionClick}
              />
            </motion.div>
          ))}
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
